import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    status: null,
    response: null,
    singleIntern: null,
}

export const getInstituteQr = createAsyncThunk(
    "getInstituteQr",
    async (body) => {
        try {
            const response = await instance.get(`/remark/institute-qr/institute-qr-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&status=${body.status}`)
            return response.data;
        } catch (error) {
            throw error
        }
    }
)
export const updateQrStatus = createAsyncThunk(
  "updateQrStatus",
  async (body) => {
    try {
      const response = await instance.post(
        `/remark/institute-qr/update-status?id=${body.id}`,
        {
          status: body.status,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const InstituteQrSlice = createSlice({
    name: "InstituteQrSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getInstituteQr.pending, (state, action) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(getInstituteQr.fulfilled, (state, action) => {
            state.loading = false;
            state.status = action.payload.status;
            state.data = action.payload;
        });
        builder.addCase(getInstituteQr.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        builder.addCase(updateQrStatus.pending, (state, action) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(updateQrStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.status = action.payload.status;
            state.data = action.payload;
        });
        builder.addCase(updateQrStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

    }
})

export default InstituteQrSlice.reducer;